export default __webpack_public_path__ + "locales/az/Translations.json?hash=a963bfc530605a80b2e56e8a68d9cf56";